<script>
    import { onMount, onDestroy, afterUpdate } from 'svelte';
    import Flatpickr from 'svelte-flatpickr';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    export let open = false;
    export let options = {};
    export let dateSelected;
    export let nextMonthArrowId;
    export let prevMonthArrowId;
    export let handleChange;

    let fp;
    let calendarVisible = false;

    afterUpdate(() => {
        if (open) {
            calendarVisible = open;
        } else {
            setTimeout(() => {
                calendarVisible = open;
            }, 500);
        }
    });

    onMount(() => {
        const nextMonthArrow = document.getElementById(nextMonthArrowId);
        const prevMonthArrow = document.getElementById(prevMonthArrowId);
        nextMonthArrow?.addEventListener('keydown', (event) => {
            handleMonthChange(event, 1);
        });
        prevMonthArrow?.addEventListener('keydown', (event) => {
            handleMonthChange(event, -1);
        });
        // Fixing lack of :focus-visible support in Safar / focus persisting after click
        nextMonthArrow?.addEventListener('click', (event) => {
            event.target.blur();
        });
        prevMonthArrow?.addEventListener('click', (event) => {
            event.target.blur();
        });
    });

    onDestroy(() => {
        const nextMonthArrow = document.getElementById(nextMonthArrowId);
        const prevMonthArrow = document.getElementById(prevMonthArrowId);
        nextMonthArrow && nextMonthArrow.removeEventListener('keydown');
        prevMonthArrow && prevMonthArrow.removeEventListener('keydown');
        nextMonthArrow && nextMonthArrow.removeEventListener('click');
        prevMonthArrow && prevMonthArrow.removeEventListener('click');
    });
    const handleMonthChange = (event, direction) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            fp.changeMonth(direction);
        }
    };

    const borderRadius = getBorderRadius('datePickerDay');

    let calendarWrapper;

    const handleReady = (event) => {
        setTimeout(() => {
            if (!calendarWrapper) {
                return;
            }

            const elements = event.detail[2].days.children;

            Array.from(elements).forEach((el) => el.classList.add(borderRadius));
        });
    };
</script>

<div
    class="pointer-events-auto z-[10] w-full p-4"
    on:click|stopPropagation
    bind:this={calendarWrapper}
>
    {#if calendarVisible}
        <Flatpickr
            name="date"
            {options}
            bind:value={dateSelected}
            on:ready={handleReady}
            on:change={handleChange}
            bind:flatpickr={fp}
        />
    {:else}
        <div class="pointer-events-none flex h-[297px] w-full min-w-[329px] flex-col p-4">
            <div class="h-8 animate-pulse-shadow rounded bg-gray-100" />
            <div class="mb-3 mt-4 h-7 animate-pulse-shadow rounded bg-gray-100" />
            <div class="h-[221px] animate-pulse-shadow rounded bg-gray-100" />
        </div>
    {/if}
</div>
